<template>
  <section class="px-4 py-12 md:py-16 bg-neutral-700">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.problem.title') }}</h2>
      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl">
        {{ t('landing.problem.body') }}
      </p>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
